import { BASE_CLASS_PREFIX } from '../base/constants';

const stepsClasses = {
    PREFIX: `${BASE_CLASS_PREFIX}-steps`,
    ITEM: `${BASE_CLASS_PREFIX}-steps-item`
};

export { stepsClasses };